import { useEffect, useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import {
  doc,
  getDoc,
} from "firebase/firestore";
import { db } from "../firebase/firebase";
import { useAuth } from "../context/AuthContext";

function StartupRecordRedirect() {
  const { recordId } = useParams();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const navigate = useNavigate();
  const { user } = useAuth();

  const [record, setRecord] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadRecord = async () => {
      try {
        // 1️⃣ Load startup record
        const recordSnap = await getDoc(
          doc(db, "startupRecords", recordId)
        );

        if (!recordSnap.exists()) {
          setError("Startup record not found.");
          return;
        }

        const recordData = recordSnap.data();

        // 2️⃣ Owner access (logged-in founder)
        if (user && recordData.userId === user.uid) {
          setRecord(recordData);
          return;
        }

        // 3️⃣ Public profile access (token-based)
        if (token) {
          const shareSnap = await getDoc(
            doc(db, "publicProfileShares", token)
          );

          if (!shareSnap.exists()) {
            setError("Invalid or expired public link.");
            return;
          }

          const share = shareSnap.data();

          if (
            share.revoked === true ||
            share.expiresAt?.toDate() < new Date() ||
            share.founderId !== recordData.userId
          ) {
            setError("You do not have access to this record.");
            return;
          }

          setRecord(recordData);
          return;
        }

        // 4️⃣ No valid access
        setError("You do not have access to this record.");
      } catch (err) {
        console.error(err);
        setError("Failed to load startup record.");
      }
    };

    loadRecord();
  }, [recordId, user, token]);

  if (error) {
    return (
      <div style={{ padding: 24 }}>
        <p>{error}</p>
        <button onClick={() => navigate(-1)}>Go back</button>
      </div>
    );
  }

  if (!record) {
    return <p style={{ padding: 24 }}>Opening record…</p>;
  }

  // 🔗 External link
  if (record.type === "link") {
    window.location.href = record.linkUrl;
    return null;
  }

  // 📄 File preview
  return (
    <div style={{ height: "100vh" }}>
      <iframe
        src={record.fileUrl}
        title="Startup Record"
        style={{ width: "100%", height: "100%", border: "none" }}
      />
    </div>
  );
}

export default StartupRecordRedirect;
